<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="660px">
        <div class="imgCanvas">
            <img v-if="imgUrl" class="w-100" :src="imgUrl" />
            <el-empty v-else :description="$t('integration.no_signature_information_yet')"></el-empty>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="handleEdit">{{ $t('public.edit') }}</el-button>
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        </div>
    </modal>
</template>

<script>
export default {
  props: ['signatureShow', 'title', 'imgUrl'],
  computed: {
    isShowDialog: {
      get: function () {
        return this.signatureShow
      },
      set: function (val) {
        this.$emit('update:signatureShow', val)// 可以优化成model  或者minx
      }
    }
  },
  mounted () {
  },
  methods: {
    handleEdit () {
      const { href } = this.$router.resolve({
        path: '/canvasName'
      })
      window.writeFn = this.$parent.writeFn
      window.open(
        href,
        '_blank',
        'height=400,width=800,top=200,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.imgCanvas {
    min-height: 270px;
    border: 1px solid var(--primary-color);
}
</style>
